<template>
  <div>
    <Head :title="form.name" />
    <h1 class="mb-8 text-3xl font-bold">
      Transaksi
      <span class="text-indigo-400 font-medium"> / </span>
      <Link class="text-indigo-400 hover:text-indigo-600" href="/porecv">
        Penerimaan PO
      </Link>
      <span class="text-indigo-400 font-medium"> / </span> Create
    </h1>
    <form @submit.prevent="store">
      <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <select-input
            v-model="form.purchase_order_m_id"
            :error="form.errors.purchase_order_m_id"
            class="pb-8 pr-6 w-full"
            label="Purchase Order">
            <option
              v-for="po in purchaseOrders"
              :key="po.id"
              :value="po.id">
              {{ po.code }}
            </option>
          </select-input>
          <text-input
            :model-value="formatDate(form.recv_date)"
            :error="form.errors.recv_date"
            class="pb-8 pr-6 w-full lg:w-1/4"
            label="Tgl Terima Barang"
            disabled />
          <select-input
            v-model="form.signature_recv01_id"
            :error="form.errors.signature_recv01_id"
            class="pb-8 pr-6 w-1/2 md:w-1/4"
            label="Mengetahui">
            <option
              v-for="employee in employees"
              :key="employee.id"
              :value="employee.id">
              {{ employee.name }}
            </option>
          </select-input>
          <text-input
            v-model="form.signature_recv02_id"
            :error="form.errors.signature_recv02_id"
            class="pb-8 pr-6 w-full md:w-1/4"
            label="Penerima" />
          <textarea-input
            v-model="form.description"
            :error="form.errors.description"
            class="pb-8 pr-6 w-full md:w-1/2"
            label="Description" />
          <select-input
            v-model="form.item_location_id"
            :error="form.errors.item_location_id"
            class="pb-8 pr-6 w-full md:w-1/2"
            label="Lokasi Item">
            <option
              v-for="itemLocation in itemLocations"
              :key="itemLocation.id"
              :value="itemLocation.id">
              {{ itemLocation.name }}
            </option>
          </select-input>
        </div>
      </div>
      <div class="w-full mt-4" />
      <div class="flex mb-6">
        <loading-button
          :loading="form.processing"
          class="btn-indigo"
          type="submit">
          <span>Load List</span>
          <span class="hidden md:inline">&nbsp;Barang PO</span>
        </loading-button>
      </div>
    </form>
  </div>
</template>

<script lang="js">
import { Head, Link } from '@inertiajs/vue3'
import { format, parse } from 'date-fns'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'
import SelectInput from '@/Shared/SelectInput'
export default {
    components: {
        Head,
        Link,
        LoadingButton,
        SelectInput,
        TextInput,
        TextareaInput,
    },
    layout: Layout,
    props: {
        purchaseOrders: Array,
        todayDate: String,
        employees: Object,
        itemLocations: Object,
    },
    remember: 'form',
    data () {
        return {
            form: this.$inertia.form({
                purchase_order_m_id: null,
                recv_date: this.todayDate,
                signature_recv01_id: null,
                signature_recv02_id: null,
                signature_recv03_id: null,
                item_location_id: null,
                description: null,
            }),
        }
    },
    methods: {
        store () {
            this.form.post('/porecv')
        },
        formatNumber (num) {
            return num ? num.toLocaleString('id-ID') : '0'
        },
        formatDate (ymd) {
            return format(parse(ymd, 'yyyy-MM-dd', new Date()), 'dd-MMM-yyyy')
        },
    },
}
</script>
